import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PICK_FORMATS, PickDateAdapter } from '../../../shared/utilities/pick-date-adapter';
import { EncuestaSatisfaccion } from '../../../shared/entities/EncuestaSatisfaccion';

@Component({
  selector: 'app-opinion',
  templateUrl: './opinion.component.html',
  styleUrls: ['./opinion.component.css'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' }],
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule,
    MatTableModule, MatPaginatorModule, MatNativeDateModule, ReactiveFormsModule, MatSelectModule]
})
export class OpinionComponent implements OnInit {
  public isAgradecimientos: boolean = false;
  public razonOpinion: string = '';
  public correoElectronico: string = '';
  public nombre: string = '';
  public fecha: Date | null = null;
  public hora: string = '';
  public parrafoTratamientoDatos: SafeHtml = '';
  public proteccionDatosPersonales: boolean = false;
  public fechaActual: Date = new Date();
  public fechaMinima: Date = new Date();
  public meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  public fechaInicio: Date = new Date();
  public calificado = false;

  public errores = {
    correoObligatorio: false,
    fechaObligatorio: false,
    correoinvalido: false,
    opinion: false
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<OpinionComponent>, private service: VisualizadorService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getParamTratamientoDatos();
    this.fechaMinima.setDate(this.fechaActual.getDate() + 7 - this.fechaActual.getDay());
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public enviarOpinion() {
    const emailPattern = /^[a-zA-Z]+([.-]?[a-zA-Z0-9]+)*@([a-zA-Z]+([.-]?[a-zA-Z]))[.]{1}[a-zA-Z]{2,}$/;
    let fechaFormateada = '';
    if (this.correoElectronico != '' && this.correoElectronico.includes('@')) {
      if (this.fecha) {
        let day = String(this.fecha.getDate()).padStart(2, '0');
        let month = this.meses[this.fecha.getMonth()];
        let year = this.fecha.getFullYear();
        fechaFormateada = `${day} de ${month} de ${year}`;
      }
      this.razonOpinion = "Interes en reunion de " + this.nombre + " - Correo: " + this.correoElectronico + " - Fecha deseada: " + fechaFormateada + " - Hora deseada: " + this.hora + "am";
      this.service.compartirOpinion(this.razonOpinion, this.correoElectronico).subscribe({
        next: (jsonWebMenu) => {
          this.isAgradecimientos = true;
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    } else {
      this.errores.correoObligatorio = true;
    }
  }

  private getParamTratamientoDatos() {
    this.service.consultaParametro('TEXTO_TRATAMIENTO_DATOS').subscribe({
      next: (response) => {
        this.parrafoTratamientoDatos = this.sanitizer.bypassSecurityTrustHtml(response);
      },
      error: (error) => {
        console.log("Error inesperado en getMenuXOpcion", error);
      }
    });
  }

  onDisableDates = (date: any) => {
    const day = (date || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 1 && day !== 3 && day !== 5 && day !== 6;
  }


  enviarCalificacion(calificacion: string) {
    var detalleEncuesta: EncuestaSatisfaccion = new EncuestaSatisfaccion();
    detalleEncuesta.fechaInicial = this.fechaInicio.getTime();
    var fechaFinal: Date = new Date();
    detalleEncuesta.fechaFinal = fechaFinal.getTime();
    detalleEncuesta.idSerie = -1;
    detalleEncuesta.nombreTematica = 'Home - video instrucciones';
    detalleEncuesta.productoOrigen = 'ESTADISTICAS_ECONOMICAS';
    detalleEncuesta.tipoEncuesta = "ENCUESTA_BASICA";

    //ENCUESTA BASICA
    detalleEncuesta.calificacion = calificacion;
    detalleEncuesta.razonCalificacion = "";

    //ENCUESTA CERTIFICADA
    detalleEncuesta.accesibilidadDatos = "";
    detalleEncuesta.ordenDatos = "";
    detalleEncuesta.utilidadDatos = "";
    detalleEncuesta.actividadEconomica = "";
    detalleEncuesta.ocupacion = "";
    detalleEncuesta.propositoDatos = "";
    detalleEncuesta.frecuenciaConsultaDatos = "";
    this.service.generarEncuestaSatisfaccion(detalleEncuesta!).subscribe({
      next: (jsonResponse) => {
        console.log('jsonResponse', jsonResponse);
      },
      error: (error) => {
        console.log("Error inesperado en getInformacionMenu", error);
      }
    });
    this.calificado = true;
  }

  validarFormularioCompleto(): boolean {
    if (this.correoElectronico && this.nombre && this.fecha && this.hora) {
      return true;
    } else {
      return false;
    }
  }

}
